import { styled, useTheme } from '@mui/material';
import { Switch } from '../SwitchButton/Switch';
import { Typography } from '../Typography/Typography';

type Props = {
  checked: boolean;
  onChange: (checked: boolean) => void;
  /** e.g. "Show inactive" / "Show archived"; the hidden-row count is appended in brackets. */
  label: string;
  count: number;
};

/** Single toggle that reveals de-emphasized (inactive/archived) rows, replacing the Active/Inactive segmented control. */
export const ShowInactiveToggle = ({ checked, onChange, label, count }: Props) => {
  const { colors } = useTheme();

  return (
    <Wrapper>
      <Switch checked={checked} onChange={(e) => onChange(e.target.checked)} />
      <Typography variant='body' color={colors.text.main}>
        {`${label} (${count})`}
      </Typography>
    </Wrapper>
  );
};

const Wrapper = styled('label')`
  display: flex;
  align-items: center;
  gap: 8px;
  height: 36px;
  cursor: pointer;
  user-select: none;
`;
